import { all, takeEvery, takeLatest, put, call } from 'redux-saga/effects';
import { pocActionTypes } from './Poc.actionTypes';
import file from '../../services/upload';
import attendance from '../../services/attendance';
import {
  addNotification,
  notificationStates,
} from '../../components/Notification';
import member from '../../services/member';

function* uploadImageSaga({ payload }) {
  try {
    yield call(file.uploadImage, payload.image, payload.name);
  } catch (error) {
    addNotification({
      message: error.message,
      level: notificationStates.error,
    });
  }
}

function* createPocSaga({ payload }) {
  try {
    yield call(file.createPOC, payload);
  } catch (error) {
    addNotification({
      message: error.message,
      level: notificationStates.error,
    });
  }
}

function* getPocDataSaga({ payload }) {
  yield put({
    type: pocActionTypes.SET_LOADING,
    payload: true,
  });
  try {
    const response = yield call(file.getPOCData, payload);
    if (response) {
      yield put({
        type: pocActionTypes.SET_POC_DATA,
        payload: response.data,
      });
    }
  } catch (error) {
    addNotification({
      message: error.message,
      level: notificationStates.error,
    });
  } finally {
    yield put({
      type: pocActionTypes.SET_LOADING,
      payload: false,
    });
  }
}

function* getApplicationInfoSaga() {
  yield put({
    type: pocActionTypes.SET_LOADING,
    payload: true,
  });
  try {
    const response = yield call(file.getApplicationInfo);
    if (response) {
      yield put({
        type: pocActionTypes.SET_APPLICATION_INFO,
        payload: response.data,
      });
    }
  } catch (error) {
    addNotification({
      message: error.message,
      level: notificationStates.error,
    });
  } finally {
    yield put({
      type: pocActionTypes.SET_LOADING,
      payload: false,
    });
  }
}

function* getAttendanceDataSaga({ payload }) {
  yield put({
    type: pocActionTypes.SET_LOADING,
    payload: true,
  });
  try {
    const response = yield call(
      attendance.getAllMembersAttendaceViaApi,
      payload.companyId,
      payload.date
    );

    if (response) {
      yield put({
        type: pocActionTypes.SET_ATTENDANCE_DATA,
        payload: response.data,
      });
    }
  } catch (error) {
    addNotification({
      message: error.message,
      level: notificationStates.error,
    });
  } finally {
    yield put({
      type: pocActionTypes.SET_LOADING,
      payload: false,
    });
  }
}

function* getUserTokenOptionsSaga({ payload }) {
  try {
    const { companyId } = payload;
    const options = yield call(
      member.getUserTokenOptionsFromLicenseDB,
      companyId
    );
    yield put({
      type: pocActionTypes.SET_USER_TOKEN_OPTIONS,
      payload: options,
    });
  } catch (error) {
    yield put({
      type: pocActionTypes.SET_USER_TOKEN_OPTIONS,
      payload: [], // fallback
    });
  }
}

export default function* pocWatcher() {
  yield all([
    takeEvery(pocActionTypes.UPLOAD_IMAGE, uploadImageSaga),
    takeEvery(pocActionTypes.CREATE_POC, createPocSaga),
    takeEvery(pocActionTypes.GET_POC_DATA, getPocDataSaga),
    takeEvery(pocActionTypes.GET_APPLICATION_INFO, getApplicationInfoSaga),
    takeEvery(pocActionTypes.GET_ATTENDANCE_DATA, getAttendanceDataSaga),
    takeEvery(pocActionTypes.GET_USER_TOKEN_OPTIONS, getUserTokenOptionsSaga),
  ]);
}
